// /src/pages/Unsubscribe.jsx
import React from "react";
import { useLocation, Link } from "react-router-dom";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function Unsubscribe() {
  const q = useQuery();
  const status = (q.get("status") || "ok").toLowerCase();
  const locale = (q.get("locale") || "uk").toLowerCase();

  const dict = {
    uk: {
      title_ok: "Відписка оформлена",
      title_not_found: "Невірний або прострочений токен",
      title_no_token: "Відсутній токен відписки",
      text_ok: "Ви успішно відписалися від новин Radiomonitor.",
      text_err:
        "Посилання некоректне або термін дії минув. Якщо ви передумали — можете знову підписатися на сторінці новин.",
      back: "На головну",
      news: "До новин",
    },
    en: {
      title_ok: "Unsubscription complete",
      title_not_found: "Invalid or expired token",
      title_no_token: "Missing unsubscribe token",
      text_ok: "You have successfully unsubscribed from Radiomonitor news.",
      text_err:
        "The link is invalid or expired. If you changed your mind, you can subscribe again on the News page.",
      back: "Back to home",
      news: "Go to News",
    },
    it: {
      title_ok: "Disiscrizione completata",
      title_not_found: "Token non valido o scaduto",
      title_no_token: "Token di disiscrizione mancante",
      text_ok: "Ti sei disiscritto con successo dalle news di Radiomonitor.",
      text_err:
        "Il link non è valido o è scaduto. Se hai cambiato idea, puoi iscriverti di nuovo nella pagina Notizie.",
      back: "Alla home",
      news: "Alle Notizie",
    },
  };

  const t = dict[locale] || dict.uk;
  const isOk = status === "ok";
  const title =
    status === "not_found" ? t.title_not_found : status === "no_token" ? t.title_no_token : t.title_ok;
  const text = isOk ? t.text_ok : t.text_err;

  return (
    <div
      style={{
        maxWidth: 720,
        margin: "48px auto",
        background: "#fff",
        borderRadius: 14,
        boxShadow: "0 12px 32px rgba(0,0,0,.15)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          background: "#00723a",
          color: "#fff",
          padding: "16px 22px",
          fontWeight: 800,
          fontSize: 20,
          letterSpacing: ".3px",
        }}
      >
        {title}
      </div>

      <div style={{ padding: "22px 24px" }}>
        <p style={{ fontSize: 16, lineHeight: 1.5, marginBottom: 18 }}>{text}</p>

        <div style={{ display: "flex", gap: 10 }}>
          <Link
            to="/"
            style={{
              padding: "10px 18px",
              fontSize: 16,
              borderRadius: 8,
              border: "1px solid #ddd",
              background: "#fff",
              textDecoration: "none",
              color: "#222",
            }}
          >
            {t.back}
          </Link>
          <Link
            to={`/${locale}/news`}
            style={{
              padding: "10px 18px",
              fontSize: 16,
              borderRadius: 8,
              border: "none",
              background: "#00723a",
              color: "#fff",
              fontWeight: 700,
              textDecoration: "none",
            }}
          >
            {t.news}
          </Link>
        </div>
      </div>
    </div>
  );
}
